import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/nuovo-progetto',
        name: 'newPrintProject',
        component: () => import("./views/newPrintProject.vue")
    },
    {
        path: '/progetti',
        name: 'printProjects',
        component: () => import("./views/printProjects.vue")
    },
    {
        path: '/progetti/:identifier',
        name: 'printProjectDetail',
        component: () => import("./views/printProjectDetail.vue")
    }
];

export default routes;
